import { createContext, useContext } from 'react';

// The page's course and activity properties (its `eventTrackingProperties`) for the events a question's
// thread sends, set where the activity lists its questions rather than threaded through every level of
// the thread. Undefined elsewhere (the instructor queues), where the thread's events say less.
const QuestionEventsContext = createContext(undefined);

export const QuestionEventsProvider = QuestionEventsContext.Provider;

export function useQuestionEventProperties() {
  return useContext(QuestionEventsContext);
}
